export default "__VITE_ASSET__BsgH6b8c__"